import React from 'react'

import { AccountFitSettings } from 'constants/firmographics'

import { SelectOption } from '@driftt/dds'

import { AccountFitSetupStatus } from 'utils/features'

export interface ICPSettingsContextType {
  accountFitEnabled: boolean
  setAccountFitEnabled: (isEnabled: boolean) => void
  accountFitSetup: AccountFitSetupStatus
  setAccountFitSetup: (accountFitSetupStatus: AccountFitSetupStatus) => void
  scoringCompletedAtLeastOnce: boolean
  hasFirmoSettings: boolean
  noParameters: boolean
  scoringInProgress: boolean
  companySizes: SelectOption<string>[]
  setCompanySizes: (companySizes: SelectOption<string>[]) => void
  countries: SelectOption<string>[]
  setCountries: (countries: SelectOption<string>[]) => void
  industries: SelectOption<string>[]
  setIndustries: (industries: SelectOption<string>[]) => void
  ICP_SWR_KEY: string
  applyDataToSelects: (data: AccountFitSettings) => void
  error: any
  showPreferencesModal: boolean
  setShowPreferencesModal: (show: boolean) => void
  hideScoresBehindLock: boolean
  defaultData: AccountFitSettings
  scoringWorkflowError: boolean
}

export const ICPSettingsContext = React.createContext<ICPSettingsContextType>({
  accountFitEnabled: false,
  setAccountFitEnabled: () => {},
  accountFitSetup: AccountFitSetupStatus.NOT_COMPLETE,
  setAccountFitSetup: () => {},
  scoringCompletedAtLeastOnce: false,
  hasFirmoSettings: false,
  noParameters: false,
  scoringInProgress: false,
  companySizes: [],
  setCompanySizes: () => {},
  countries: [],
  setCountries: () => {},
  industries: [],
  setIndustries: () => {},
  ICP_SWR_KEY: '',
  applyDataToSelects: () => {},
  error: {},
  showPreferencesModal: false,
  setShowPreferencesModal: () => {},
  hideScoresBehindLock: true,
  defaultData: {
    EmployeeCount: [],
    Countries: [],
    Industries: []
  },
  scoringWorkflowError: false
})
